import { DesignTokenTypedData, ThemeOverrideOrigin } from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTOThemeOverride = DesignTokenTypedData.and(
  z.object({
    tokenPersistentId: z.string(),
    origin: ThemeOverrideOrigin.optional(),
  })
);

export type DTOThemeOverride = z.infer<typeof DTOThemeOverride>;

//
// Write
//

export const DTOThemeOverrideCreatePayload = DesignTokenTypedData.and(
  z.object({
    tokenPersistentId: z.string(),
  })
);

export type DTOThemeOverrideCreatePayload = z.infer<typeof DTOThemeOverrideCreatePayload>;
